export default __webpack_public_path__ + "static/media/mht.f8492891.svg";